<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('groupmanage.gname')">
        <el-input :placeholder="$t('groupmanage.placeholder')" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="联系人" prop="link_person"></el-table-column>
      <el-table-column label="联系人电话" prop="link_phone"></el-table-column>
      <el-table-column label="法人" prop="legal_person"></el-table-column>
      <el-table-column label="法人电话" prop="legal_phone"></el-table-column>
      <el-table-column label="省" prop="province"></el-table-column>
      <el-table-column label="市" prop="city"></el-table-column>
      <el-table-column label="区" prop="region"></el-table-column>
      <el-table-column label="地址" prop="address"></el-table-column>
      <el-table-column label="创建时间" prop="create_time"></el-table-column>
      <el-table-column label="修改时间" prop="modify_time"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="240px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text"   @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <!-- 新增or修改街道 -->
    <el-dialog :visible.sync="visible.editGroup"
      :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="名称" prop="name" label-width="20%">
              <el-input placeholder="请输入名称" v-model="form.name" maxlength="30" show-word-limit/>
            </el-form-item>

            <el-form-item label="联系人" prop="link_person" label-width="20%">
              <el-input placeholder="请输入联系人" v-model="form.link_person" maxlength="10" show-word-limit/>
            </el-form-item>
            <el-form-item label="联系人电话" prop="link_phone" label-width="20%">
              <el-input placeholder="请输入联系人电话" v-model="form.link_phone" maxlength="15" show-word-limit/>
            </el-form-item>
            <el-form-item label="法人" prop="legal_person" label-width="20%">
              <el-input placeholder="请输入法人" v-model="form.legal_person" maxlength="10" show-word-limit/>
            </el-form-item>
            <el-form-item label="法人电话" prop="legal_phone" label-width="20%">
              <el-input placeholder="请输入法人电话" v-model="form.legal_phone" maxlength="15" show-word-limit />
            </el-form-item>

            <el-form-item label="省" prop="provinceCode" label-width="20%">
              <el-select v-model="form.provinceCode" placeholder="请选择省" clearable @change="handleProvinceChange">
                <el-option v-for="item in provinceOptions" :key="item.ID" :label="item.Name"
                  :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市" prop="cityCode" label-width="20%">
              <el-select v-model="form.cityCode" placeholder="请先选择市" clearable :disabled="!form.provinceCode"
                @change="handleCityChange">
                <el-option v-for="item in cityOptions" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区" prop="regionCode" label-width="20%">
              <el-select v-model="form.regionCode" placeholder="请先选择区" clearable :disabled="!form.cityCode">
                <el-option v-for="item in regionOptions" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地址" prop="address" label-width="20%">
              <el-input placeholder="请输入地址" v-model="form.address" />
            </el-form-item>

            <el-form-item label="备注" prop="remark" label-width="20%">
              <el-input placeholder="请输入备注" v-model="form.remark" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { getChargePileProducerList, modifyChargePileProducer, delChargePileProducer, addChargePileProducer, GetAllList } from "@/api/dev_archive"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      visible: {
        editGroup: false
      },
      tableData: [],
      areaData: [],
      provinceOptions: [], // 省选项
      cityOptions: [],     // 市选项
      regionOptions: [],   // 区选项
      form: {
        name: "",
        link_person:"",
        link_phone:"",
        legal_person:"",
        legal_phone:"",
        province: "",
        city: "",
        region: "",
        address:"",
        remark: "",
        provinceCode: "",  // 省代码
        cityCode: "",      // 市代码
        regionCode: ""     // 区代码
      },
      formRules: {
        name: [{ required: true, message: "请输入街道名", trigger: "blur" }],
        provinceCode: [{ required: true, message: "请选择省", trigger: "change" }],
        cityCode: [{ required: true, message: "请选择市", trigger: "change" }],
        regionCode: [{ required: true, message: "请选择区", trigger: "change" }],
      },
      filter: {
        groupName: ""
      },
      loading: false,
      isUpdate: true,
      gid: "" //街道id
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    // this.formRules = {
    //   name: [{ required: true, message: "请输入街道名", trigger: "blur" }],
    //   province: [{ required: true, message: "请输入省", trigger: "blur" }],
    //   city: [{ required: true, message: "请输入市", trigger: "blur" }],
    //   region: [{ required: true, message: "请输入区", trigger: "blur" }],
    //   //platformTheme: [
    //   //  { required: true, message: '请选择平台主题', trigger: 'change' }
    //   //]
    // }
    this.getData()
  },
  methods: {
    // 加载地区数据
    async loadAreaData() {
      if (this.areaData.length === 0 && !this.areaDataLoading) {
        this.areaDataLoading = true
        try {
          const res = await GetAllList()
          this.areaData = res.data
          // 初始化省选项
          this.provinceOptions = this.areaData.filter(item => !item.ParentCode)
        } catch (error) {
          console.error('加载地区数据失败:', error)
          this.$message.error('加载地区数据失败')
        } finally {
          this.areaDataLoading = false
        }
      }
    },
    onUpdate(row) {
      this.visible.editGroup = true
      this.isUpdate = true
      this.form.name = row.name
      this.form.link_person = row.link_person
      this.form.link_phone = row.link_phone
      this.form.legal_person = row.legal_person
      this.form.legal_phone = row.legal_phone
      this.form.address = row.address
      this.form.province = row.province
      this.form.city = row.city
      this.form.region = row.region
      this.form.remark = row.remark
      this.gid = row.ID

      // 先清空省市区代码
      this.form.provinceCode = ''
      this.form.cityCode = ''
      this.form.regionCode = ''
      if (this.areaData.length > 0) {
        this.setAreaCodes(row)
      } else {
        // 如果没有地区数据，先加载再设置
        this.loadAreaData().then(() => {
          this.setAreaCodes(row)
        })
      }
    },
    setAreaCodes(row) {
      // 设置省代码
      if (row.province) {
        const provinceObj = this.areaData.find(item =>
          item.Name === row.province && !item.ParentCode
        )
        if (provinceObj) {
          this.form.provinceCode = provinceObj.ID
          this.handleProvinceChange(provinceObj.ID)

          // 设置市代码
          if (row.city) {
            // 等待省选择变化完成
            this.$nextTick(() => {
              const cityObj = this.cityOptions.find(item => item.Name === row.city)
              if (cityObj) {
                this.form.cityCode = cityObj.ID
                this.handleCityChange(cityObj.ID)

                // 设置区代码
                if (row.region) {
                  // 等待市选择变化完成
                  this.$nextTick(() => {
                    const regionObj = this.regionOptions.find(item => item.Name === row.region)
                    if (regionObj) {
                      this.form.regionCode = regionObj.ID
                    }
                  })
                }
              }
            })
          }
        }
      }
    },
    handleProvinceChange(provinceCode) {
      console.log('省份选择变化:', provinceCode)
      console.log('省份代码类型:', typeof provinceCode, '值:', provinceCode)

      // 清空市和区的选项和选中值
      this.form.cityCode = ''
      this.form.regionCode = ''
      this.cityOptions = []
      this.regionOptions = []

      if (provinceCode) {
        // 过滤出该省下的市
        console.log('开始过滤市级数据，省份代码:', provinceCode)
        console.log('地区数据类型:', typeof this.areaData, '长度:', this.areaData.length)

        const filteredCities = this.areaData.filter(item => {
          console.log('检查项:', item.Name, 'ParentCode:', item.ParentCode, 'ParentCode类型:', typeof item.ParentCode)
          const match = String(item.ParentCode) === String(provinceCode)
          if (match) {
            console.log('匹配到:', item.Name)
          }
          return match
        })

        console.log('过滤结果数量:', filteredCities.length)
        console.log('过滤结果:', JSON.parse(JSON.stringify(filteredCities)))

        this.cityOptions = filteredCities
      }
    },

    handleCityChange(cityCode) {
      console.log('城市选择变化:', cityCode)
      // 清空区的选项和选中值
      this.form.regionCode = ''
      this.regionOptions = []

      if (cityCode) {
        // 过滤出该市下的区
        this.regionOptions = this.areaData.filter(item =>
          String(item.ParentCode) === String(cityCode)
        )
        console.log('区级选项数量:', this.regionOptions.length)
      }
    },
    // fileChange(fileList, field) {
    //   this.form[field] = fileList
    // },
     onDelete(row) {
      this.$confirm("确定要删除该桩厂家吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delChargePileProducer(row).then((res) => {
            this.$message.success(`删除成功`)
            this.toFilter()
          })
        })
        .catch(() => {})
    },
    
    getData() {
      this.loading = true
      getChargePileProducerList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false
      this.form = this.$options.data().form
      this.cityOptions = []
      this.regionOptions = []
      // 确保有地区数据
      if (this.areaData.length === 0) {
        this.loadAreaData()
      }
    },
    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          // 根据选择的代码获取对应的名称
          const getAreaNameByCode = (code) => {
            const area = this.areaData.find(item => item.ID === code)
            return area ? area.Name : ''
          }
          const loading = this.$loading()
          const reqData = {
            name: this.form.name,
            link_person: this.form.link_person,
            link_phone: this.form.link_phone,
            legal_person: this.form.legal_person,
            legal_phone: this.form.legal_phone,
            address: this.form.address,
            province: getAreaNameByCode(this.form.provinceCode),
            city: getAreaNameByCode(this.form.cityCode),
            region: getAreaNameByCode(this.form.regionCode),
            remark: this.form.remark,
          }
          if (this.isUpdate) {
            reqData.ID = this.gid
            modifyChargePileProducer(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addChargePileProducer(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
